import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class I18nHttpClient {
  constructor(
    private http: HttpClient,
    private translate: TranslateService,
  ) {}

  createI18nHeader(headers: HttpHeaders) {
    headers.append("Accept-language", this.translate.currentLang);
  }

  get(url) {
    let headers = new HttpHeaders();
    this.createI18nHeader(headers);
    return this.http.get(url, {
      headers: headers,
    });
  }

  post(url, data) {
    let headers = new HttpHeaders();
    this.createI18nHeader(headers);
    return this.http.post(url, data, {
      headers: headers,
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/services/i18n-http.service.ts